import { render, staticRenderFns } from "./contact-data.vue?vue&type=template&id=8c1abec2&scoped=true&"
import script from "./contact-data.vue?vue&type=script&lang=js&"
export * from "./contact-data.vue?vue&type=script&lang=js&"
import style0 from "./contact-data.vue?vue&type=style&index=0&id=8c1abec2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1abec2",
  null
  
)

export default component.exports